import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadingItems } from '../../redux/actions';
import { authSelector, itemsSelector } from '../../redux/selectors';
import { useAuth, useSearch, useUrl } from '@ofqual/portal-core/core/hooks';
import { ItemsList } from './ItemsList';

import { Pager } from '@ofqual/portal-components/components/Pager';
import { FilterControls } from './FilterControls';
import { ModuleAppBar } from '../ModuleAppBar';
import { makeStyles } from '@material-ui/core';

import { useLocation, useHistory } from 'react-router-dom';

import { ListTabs } from '../list/ListTabs';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginTop: theme.contentOffsets.AFTER_SECONDARY_APPBAR,
    },
  };
});

export const Items: React.FC = () => {
  const dispatch = useDispatch();
  const items = useSelector(itemsSelector);
  const { experimentalFeatures } = useAuth(authSelector);
  const { searchParams, navigateToNextPage } = useSearch(useUrl());
  const base = useLocation().pathname.split('/')[1];
  const year = useLocation().pathname.split('/')[2];

  const history = useHistory();

  const enabledYears: string[] = [];

  if (experimentalFeatures.find(x => x.moduleName === "portal-soc/2022" && x.featureName === "portal-soc-tabs")) {
    enabledYears.push('2022');
  }
  if (experimentalFeatures.find(x => x.moduleName === "portal-soc/2023" && x.featureName === "portal-soc-tabs")) {
    enabledYears.push('2023');
  }
  if (experimentalFeatures.find(x => x.moduleName === "portal-soc/v2" && x.featureName === "portal-soc-tab-2024")) {
    enabledYears.push('2024');
  }
  if (experimentalFeatures.find(x => x.moduleName === "portal-soc/v2" && x.featureName === "portal-soc-tab-2025")) {
    enabledYears.push('2025');
  }

  enabledYears.sort((a, b) => parseInt(b) - parseInt(a));

  useEffect(() => {
    if (!enabledYears.includes(year)) {
      const redirectYear = enabledYears[0];
      history.push(`/${base}/${redirectYear}`);
    }
  }, [year, base, history, enabledYears]);

  useEffect(() => {
    dispatch(loadingItems(searchParams, year));
  }, [dispatch, searchParams, year]);

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ModuleAppBar>
        <FilterControls />
      </ModuleAppBar>

      <ListTabs />

      <Pager state={items} navigateToNextPage={navigateToNextPage} />

      <div>{items.hasData && <ItemsList state={items} />}</div>
    </div>
  );
};
